import React, { Component } from 'react';
import ResetForm from '../components/views/Login/PasswordResetForm';

export default ResetForm;
